import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { Rocket } from 'lucide-react'
import { useLaunchFlow } from '../context/launch-flow-context'

// The single "next action" for outreach setup, driven by the first incomplete
// checklist step (Profile → Review → Connect LinkedIn → Launch).
// Labels stay short — the value pitch lives in the surrounding copy. All
// state (dialogs, guards, launch) lives in the launch-flow context so this can
// be dropped anywhere pre-launch and behave identically.
export function OutreachSetupCta({ size = 'lg' }: { size?: 'md' | 'lg' }) {
  const { checklist, contactsLabel, openStep, launch, launchPending } = useLaunchFlow()
  const first = checklist.firstIncomplete

  if (first === null) {
    return (
      <CtaButton onClick={launch} size={size} loading={launchPending} icon={<Rocket />}>
        {launchPending ? 'Launching…' : 'Launch campaign'}
      </CtaButton>
    )
  }

  const label =
    first.id === 'profile'
      ? `Unlock ${contactsLabel} contacts`
      : first.id === 'review'
        ? `Review ${contactsLabel} intros`
        : 'Connect LinkedIn'

  return (
    <CtaButton onClick={() => openStep(first.id)} size={size} arrow>
      {label}
    </CtaButton>
  )
}
